import React, { useState, useEffect } from 'react';
import { getDatabase, ref, query, orderByChild, equalTo, onValue } from 'firebase/database';
import { useAuth } from '../context/AuthContext';
import './RefundManagement.css'; // Reusing the same CSS for a consistent look
import { FaSpinner } from 'react-icons/fa';

const StudentRefunds = () => {
    const { currentUser } = useAuth();
    const [myRequests, setMyRequests] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!currentUser) return;

        const db = getDatabase();
        const requestsRef = ref(db, 'refundRequests');
        
        const studentId = currentUser.uid;

        const qRequests = query(requestsRef, orderByChild('studentId'), equalTo(studentId));

        const unsubscribeRequests = onValue(qRequests, (snapshot) => {
            const data = snapshot.val();
            const loadedRequests = data ? Object.keys(data).map(key => ({ id: key, ...data[key] })) : [];
            setMyRequests(loadedRequests.sort((a, b) => new Date(b.requestedAt) - new Date(a.requestedAt)));
            setLoading(false);
        });

        return () => {
            unsubscribeRequests();
        };
    }, [currentUser]);

    if (loading) return <div className="text-center"><FaSpinner className="spinner" /></div>;

    return (
        <div className="refund-management-container">
            <h2>My Refund Requests</h2>
            
            <div className="table-responsive">
                <table className="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Amount (₦)</th>
                            <th>Reason</th>
                            <th>Bank Details</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {myRequests.length > 0 ? (
                            myRequests.map(req => (
                                <tr key={req.id}>
                                    <td>{new Date(req.requestedAt).toLocaleString()}</td>
                                    <td>{req.amount.toLocaleString()}</td>
                                    <td>{req.reason}</td>
                                    <td>{req.bankDetails ? `${req.bankDetails.accountName}, ${req.bankDetails.bankName}, ${req.bankDetails.accountNumber}`: 'N/A'}</td>
                                    <td><span className={`badge badge-${req.status}`}>{req.status}</span></td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" className="text-center">You have not made any refund requests.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default StudentRefunds;
